"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manualField = void 0;
const mobx_1 = require("mobx");
const Field_1 = require("../Field");
class ManualField extends Field_1.default {
    constructor(params) {
        super(params);
        (0, mobx_1.makeObservable)(this, {
            change: mobx_1.action
        });
    }
    change(newValue) {
        this.setValue(newValue);
        this.syncError();
    }
    set(newValue) {
        this.change(newValue);
    }
    select(newValue) {
        this.change(newValue);
    }
}
exports.default = ManualField;
function manualField(params) {
    return new ManualField(params);
}
exports.manualField = manualField;
